module.exports = __webpack_public_path__ + "img/avatar_jason.ff758ea9.svg";